import posthog from "posthog-js";
import { PostHogErrorBoundary, PostHogProvider as PHProvider } from "posthog-js/react";
import React from "react";
import { getRuntimeEnv } from "vite-runtime-env-script-plugin/getRuntimeEnv";

import { ErrorBoundary } from "@/components";

export const PostHogProvider = ({ children } : { children: React.ReactNode }) => {
    const POSTHOG_PUBLIC_API_KEY = getRuntimeEnv("POSTHOG_PUBLIC_API_KEY");

    const POSTHOG_HOST_URL = getRuntimeEnv("POSTHOG_HOST_URL");

    if (!POSTHOG_PUBLIC_API_KEY) throw new Error(" POSTHOG_PUBLIC_API_KEY is not defined");

    if (!POSTHOG_HOST_URL) throw new Error(" POSTHOG_HOST_URL is not defined");

    const options = { api_host: POSTHOG_HOST_URL }; // eslint-disable-line

    window.onerror = function ( // eslint-disable-line
        message,
        source,
        _,
        __,
        error,
    ) {
        posthog.captureException(error);

        posthog.capture(
            "Error",
            {
                message,
                source,
            },
        );
    };

    return (
        <PHProvider
            apiKey={POSTHOG_PUBLIC_API_KEY}
            options={options}
        >
            <PostHogErrorBoundary fallback={<ErrorBoundary>{children}</ErrorBoundary>}>
                {children}
            </PostHogErrorBoundary>
        </PHProvider>
    );
};
